import { render, staticRenderFns } from "./AutoPostBoostingDetails.vue?vue&type=template&id=37361caa&scoped=true&"
import script from "./AutoPostBoostingDetails.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AutoPostBoostingDetails.vue?vue&type=style&index=1&id=37361caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37361caa",
  null
  
)

export default component.exports